import React from 'react';
import {Pie} from "react-chartjs-2";

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        const data1 = (pageData?.Item1 || 0) + (pageData?.Item5 || 0) + (pageData?.Item9 || 0) + (pageData?.Item13 || 0);
        const data2 = (pageData?.Item2 || 0) + (pageData?.Item6 || 0) + (pageData?.Item10 || 0) + (pageData?.Item14 || 0);
        const data3 = (pageData?.Item3 || 0) + (pageData?.Item7 || 0) + (pageData?.Item11 || 0) + (pageData?.Item15 || 0);
        const data4 = (pageData?.Item4 || 0) + (pageData?.Item8 || 0) + (pageData?.Item12 || 0) + (pageData?.Item16 || 0);

        const data = {
            labels: [
                'The Art of Persuasion',
                'Logical Facts',
                'Sell the Benefits',
                'Negotiate the Deal'
            ],
            datasets: [{
                data: [data1, data2, data3, data4],
                backgroundColor: [
                    '#fec057',
                    '#fecd79',
                    '#fed99a',
                    '#ffe6bc'
                ],
                hoverBackgroundColor: [
                    'rgba(254,192,87,0.85)',
                    'rgba(254,205,121,0.85)',
                    'rgba(254,217,154,0.85)',
                    'rgba(255,230,188,0.85)'
                ]
            }]
        };

        const options = {
            maintainAspectRatio: false,
            responsive: false,
            legend: {
                position: 'right',
                labels: {
                    boxWidth: 10
                }
            }
        };

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">


                                            <div className={'bg-yellow-font-bold'} style={{textAlign: 'center'}}>
                                                Primary Preferences:Sell the Benefits, Logical Facts<br/>Secondary
                                                Preferences:The Art of Persuasion, Negotiate the Deal
                                            </div>

                                            <div className="mobile-scroll chart-pie-center" style={{width: '100%', overflow: 'auto', height: '500px'}}>
                                                <Pie data={data} options={options} height={500} width={500}/>
                                            </div>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">WHAT THIS MEANS FOR YOU</span>
                                            </div>
                                            <div className="desktop ipad-portrait-show">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task tablesrink mutitable2">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="center" valign="center"
                                                            className="green_curve ">Primary Preference
                                                        </th>
                                                        <th width="20%" align="center" valign="center"
                                                            className="">Secondary Preference
                                                        </th>
                                                        <th width="60%" align="left" valign="top"
                                                            className=" green_curve1"></th>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen" rowSpan="3"><p
                                                            className="subtiltereg">The art of
                                                            persuasion</p>
                                                        </td>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen">Logical facts
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You mostly rely on using
                                                            logic to influence and persuade people. It makes
                                                            sense to you and you present the key points to win
                                                            their commitment.

                                                        </p> <br/>
                                                            <div className="uiheading"><p><span
                                                                className="subtiltereg">Risk:</span> Be careful
                                                                not to oversell the positive aspects and
                                                                downplay the risks. You may only target people
                                                                who respond to
                                                                facts and figures and neglect describing the
                                                                overall concept.</p></div>
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="darkgreen">Sell the benefits
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen"><p>You tend to rely most on
                                                            your presentation style. You’re likely to use energy
                                                            and enthusiasm to try to sell the positive aspects
                                                            to stakeholders.</p>
                                                            <div className="uiheading"><br/><p><span
                                                                className="subtiltereg">Risk:</span> Be careful
                                                                not to oversell the positive aspects and
                                                                downplay the risks. You may try to target those
                                                                who will respond
                                                                to the concept rather than hard facts and
                                                                figures.</p></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="20%" align="center" valign="center"
                                                            className="lightgreen">Negotiate the deal
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="lightgreen"><p>You’re probably aware of
                                                            your ability to influence others and use
                                                            this to try to persuade them of a ‘best case’
                                                            outcome.</p> <br/>
                                                            <div className="uiheading"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                have a tendency to be very persuasive about your
                                                                plan’s immediate benefits but fail to describe
                                                                what it may deliver
                                                                in the long-term or in a broader context.</p>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>The art of persuasion</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>Logical facts </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">

                                                            <p>You mostly rely on using logic to influence and
                                                                persuade people. It makes sense to you and you
                                                                present the key points to win their commitment.

                                                            </p> <br/>
                                                            <div className="uiheading"><p><span
                                                                className="subtiltereg">Risk:</span> Be careful
                                                                not to oversell the positive aspects and
                                                                downplay the risks. You may only target people
                                                                who respond to
                                                                facts and figures and neglect describing the
                                                                overall concept.</p></div>
                                                        </td>

                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>The art of persuasion</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top" className="darkgreen">

                                                            <p>Sell the benefits</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-right">
                                                            <p>You tend to rely on emphasising the opportunities
                                                                your idea offers
                                                                to persuade people to commit to it.

                                                            </p><br/>
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Risk:</span> You might
                                                                be challenged about the plan’s detail and
                                                                your logic.</p></div>
                                                        </td>


                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Primary
                                                            Preference
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>The art of persuasion</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">Secondary Preference</td>
                                                        <td valign="top">
                                                            <p>Negotiate the deal </p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius"></td>
                                                        <td valign="top" id="m-border-light">

                                                            <p>You’re probably aware of your ability to
                                                                influence others and use
                                                                this to try to persuade them of a ‘best case’
                                                                outcome.</p> <br/>
                                                            <div className="uiheading"><p><span
                                                                className="subtiltereg">Risk:</span> You may
                                                                have a tendency to be very persuasive about your
                                                                plan’s immediate benefits but fail to describe
                                                                what it may deliver
                                                                in the long-term or in a broader context.</p>
                                                            </div>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}